import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';

export default function FormHeading({ children, data }) {
  return <HeaderContainerForm
    title='Forms'
    data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
    onCancel={() => history.goBack()} >
    {children}
  </HeaderContainerForm>
}
